<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="livechat">
    <transition name="fade">
      <div
        v-show="isInitialized"
        class="chat-events"
      >
        <button
          type="button"
          class="btn btn-chat-close"
          aria-label="close chat"
          @click="closeChat"
        >
          <Close class="icon" />
        </button>
        <div class="chat-events-gradient" />
        <web-conversations
          ref="webConversations"
          :web-conversations-config-id="webConversationsConfigId"
        />
      </div>
    </transition>
    <form
      name="livechat"
      class="chat-input-form"
      novalidate
      autocomplete="off"
    >
      <!-- eslint-disable-next-line vuejs-accessibility/form-control-has-label -->
      <input
        v-model="userInput"
        type="text"
        name="chat-input"
        class="chat-input"
        :placeholder="i18n.livechat.inputplaceholder"
        :aria-label="i18n.livechat.inputplaceholder"
        @focus="initChat"
      >
      <kf-button
        type="submit"
        class="chat-submit-btn"
        aria-label="submit"
        @click.prevent="handleUserInputEvent()"
      />
    </form>
  </div>
</template>

<script>
export default {
  name: 'Livechat',
  components: {
    WebConversations: () =>
      import(
        /* webpackChunkName: "main" */ '@/components/livechat/components/WebConversations.vue'
      ),
    KfButton: () => import(/* webpackChunkName: "main" */ '@/components/base/button/Button.vue'),
    Close: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Close.vue'),
  },
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    locale: {
      type: String,
      default: 'en',
    },
    livechat: {
      type: Boolean,
      default: false,
    },
    webConversationsConfigId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      debug: false,
      availability: 'offline',
      isLoaded: false,
      isInitialized: false,
      chatId: null,
      threadId: null,
      users: [],
      messages: [],
      userInput: '',
      isTyping: false,
      lastAuthorId: null,
    };
  },
  methods: {
    async initChat() {
      this.isInitialized = true;
      this.$emit('open');
      // this.$refs.webConversations.shadowDomStyling;
    },
    async handleUserInputEvent() {
      if (this.userInput) {
        this.$refs.webConversations.askQuestion(this.userInput);
        this.userInput = '';
      }
    },
    closeChat() {
      this.isInitialized = false;

      if (typeof this.$sessionStorage !== 'undefined') {
        this.$sessionStorage.set('isInitialized', this.isInitialized);
      }

      this.$emit('close');
    },
  },
};
</script>

<style lang="postcss">
.livechat {
  @apply relative w-full mx-auto px-4;

  @screen md {
    @apply px-0;
  }

  .chat-events,
  .chat-input-form {
    @apply w-full relative mb-4;
  }

  .chat-events {
    @apply mx-auto;

    --chat-height: 360px;
    height: var(--chat-height, 360px);

    @screen md {
      --chat-height: 550px;
      height: var(--chat-height, 550px);
      max-width: 600px;
    }

    @screen lg {
      @apply ml-auto mr-0;
    }

    &-gradient {
      @apply absolute left-0 bottom-0 w-full rounded rounded-t-none h-full;
      box-shadow: 0 1px 0px 1px rgba(0, 0, 0, 0.05);
      background: linear-gradient(0deg, rgba(255, 255, 255, 1) 30%, rgba(0, 0, 0, 0) 70%);
      backdrop-filter: blur(2px);
    }
  }

  .chat-input-form {
    @apply pr-4 mx-auto;
    max-width: 600px;

    .chat-input {
      @apply w-full text-xl bg-white px-11 py-4 rounded-lg focus:outline-none shadow-md;
    }
    .chat-submit-btn {
      @apply absolute w-12 h-12;
      background-image: url('~@/assets/svg/chat-search-btn.svg?inline');
      top: 7px;
      right: 0;
    }

    @screen md {
      @apply ml-auto;
    }

    @screen lg {
      @apply mr-0;
    }
  }

  .btn-chat-close {
    @apply absolute right-16 w-6 h-6 min-w-0 rounded z-30 top-[25px];
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-property: opacity, max-height;
  transition-delay: 500ms, 500ms;
  transition-duration: 300ms, 300ms;
  transition-timing-function: linear, linear;
  max-height: var(--chat-height);
}

.fade-enter,
.fade-leave-to {
  transition-delay: 0ms;
  opacity: 0;
  max-height: 0px;
}
</style>
